export const PLACEHOLDER_KEY = '-';

export const HIDDEN_BALANCE_KEY = '******';
